import { render } from "./ItemsSlider.vue?vue&type=template&id=128df556&scoped=true"
import script from "./ItemsSlider.vue?vue&type=script&lang=js"
export * from "./ItemsSlider.vue?vue&type=script&lang=js"

import "./ItemsSlider.vue?vue&type=style&index=0&id=128df556&lang=scss"
import "./ItemsSlider.vue?vue&type=style&index=1&id=128df556&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128df556"]])

export default __exports__